<div class="table-wrap">
    <table>
        <tr>
            <th class="label">Activity Category</th>
            <ng-template ngFor let-jobTitle [ngForOf]="jobTitles">
                <th>{{ jobTitle.abbreviation }}</th>
                <th class="separator"></th>
                <th>Patient</th>
                <th></th>
            </ng-template>
        </tr>
        <tr *ngFor="let row of staffingGrid">
            <td class="label">{{ row[0].acuityCategory }}</td>
            <ng-template ngFor let-cell [ngForOf]="row">  
                <td>
                    <smt-staffing-grid-value [(gridCell)]="cell.numerator" (keyPressed)="updateShiftCell($event)" [required]="true" [readOnly]="readOnly"></smt-staffing-grid-value>
                </td>
                <td class="separator">:</td>
                <td>
                    <smt-staffing-grid-value [(gridCell)]="cell.denominator" (keyPressed)="updateUosCell($event)" [required]="true" [readOnly]="readOnly"></smt-staffing-grid-value>
                </td>       
                <td></td>
            </ng-template>
        </tr>
    </table>
</div>
